import autoBind from 'react-autobind';
import Avatar from 'material-ui/Avatar';
import {connect} from 'react-redux';
import Drawer from 'material-ui/Drawer';
import Folder from 'material-ui/svg-icons/file/folder';
import {handleApiError} from '../../shared/services';
import Home from 'material-ui/svg-icons/action/home';
import {Map} from 'immutable';
import muiTheme from '../../../styles/teamologyTheme';
import Public from 'material-ui/svg-icons/social/public';
import SideNavigationBadges from '../../sideNavigationBadges/components/SideNavigationBadges';
import SideNavigationTitle from '../../sideNavigationTitle/components/SideNavigationTitle';
import Subject from 'material-ui/svg-icons/action/subject';
import ViewModule from 'material-ui/svg-icons/action/view-module';
import {browserHistory, Link, withRouter} from 'react-router';
import {List, ListItem} from 'material-ui/List';
import {
  loadSideNavigation,
  onFoundationsOpen,
} from '../actions';
import React, {Component, PropTypes} from 'react';

class SideNavigationBar extends Component {
  constructor(props) {
    super(props);

    autoBind(this);
  }

  componentDidMount() {
    const {router} = this.props;
    this.props.loadSideNavigation()
      .catch(error => handleApiError(error, router, 'An error occurred while attempting to load the Side Navigation list.', 'Error'));
  }

  handleNestedListToggle() {
    const {onFoundationsOpen, foundationsIsOpen} = this.props;

    onFoundationsOpen(!foundationsIsOpen);
  }

  getItemStyle(path = '', defaultStyle = {}) {
    const currentPath = browserHistory.getCurrentLocation().pathname;
    return currentPath === path ? Object.assign(defaultStyle, muiTheme.selectedListItem) : defaultStyle;
  }

  render() {
    const {sideNavigationItems, foundationsIsOpen} = this.props;
    const firstMenuItemStyle = {
      marginTop: 50,
    };

    const pathMap = {
      dashboard: () => '/',
      library: () => '/library',
      introduction: () => '/introduction',
      character: id => `/detail/${id}`,
      community: () => '/community',
    };

    const nestedItems = sideNavigationItems.toArray().map(sideNavigationItem =>
      <ListItem
        key={sideNavigationItem.get('id')}
        leftAvatar={
          <Avatar size={30} src={require(`../images/${sideNavigationItem.get('navAvatarImageName') || 'img-nopic'}@2x.png`)}/>
          }
        containerElement={<Link to={pathMap.character(sideNavigationItem.get('id'))} />}
        className={`character-list-item ${sideNavigationItem.get('name')}`}
        primaryText={sideNavigationItem.get('name')}
        secondaryText={sideNavigationItem.get('foundationShort')}
        style={this.getItemStyle(pathMap.character(sideNavigationItem.get('id')))} />);

    nestedItems.unshift(
      <ListItem
        key="0"
        containerElement={<Link to={pathMap.introduction()} />}
        leftIcon={<Subject />}
        primaryText="Introduction"
        style={this.getItemStyle(pathMap.introduction())} />);

    return (
      <div className="side-navigation">
        <div className="side-navigation-title">
          <SideNavigationTitle />
        </div>
        <div className="badges">
          <SideNavigationBadges />
        </div>
        <Drawer className="side-navigation-drawer">
          <List>
            <ListItem
              leftIcon={<Home />}
              style={this.getItemStyle(pathMap.dashboard(), firstMenuItemStyle)}
              containerElement={<Link to={pathMap.dashboard()} />}
              primaryText="Dashboard" />
            <ListItem
              leftIcon={<ViewModule />}
              primaryText="Foundations"
              initiallyOpen={foundationsIsOpen}
              onNestedListToggle={this.handleNestedListToggle}
              primaryTogglesNestedList
              nestedItems={nestedItems} />
            <ListItem
              leftIcon={<Folder />}
              primaryText="Library"
              containerElement={<Link to={pathMap.library()} />}
              style={this.getItemStyle(pathMap.library())} />
            <ListItem
              leftIcon={<Public />}
              primaryText="Community"
              containerElement={<Link to={pathMap.community()}
              style={this.getItemStyle(pathMap.community())} />} />
          </List>
        </Drawer>
      </div>
    );
  }
}

SideNavigationBar.propTypes = {
  foundationsIsOpen: PropTypes.bool.isRequired,
  loadSideNavigation: PropTypes.func.isRequired,
  onFoundationsOpen: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  sideNavigationItems: PropTypes.instanceOf(Map).isRequired,
};

function mapStateToProps(state) {
  const {sideNavigation} = state.features.layout.pages;

  return {
    loading: sideNavigation.get('loading'),
    sideNavigationItems: sideNavigation.get('sideNavigationItems'),
    foundationsIsOpen: sideNavigation.get('foundationsIsOpen')
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    loadSideNavigation,
    onFoundationsOpen,
  }
)(SideNavigationBar));



// WEBPACK FOOTER //
// ./app/features/layout/components/SideNavigationBar.js